import { Component, OnInit } from '@angular/core';
// import CryptoJS from "crypto-js";
import axios from 'axios';
// import aes256 from 'aes256';
import { EncryptionService } from '../encryption.service';
// import { MapWrapperService } from '../map-wrapper.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

declare var MapmyIndia: any; // Declaring Mapmyindia
declare var L: any; // Declaring L
@Component({
  selector: 'app-microsite',
  templateUrl: './microsite.component.html',
  styleUrls: ['./microsite.component.scss'],
})
export class MicrositeComponent implements OnInit {
  imgModal: boolean = false;
  tncModal: boolean = false;
  isPreview: boolean = false;
  // baseURL = 'https://uat.mswipetech.co.in/MSwipeCreditEMIApi/api/';
  baseURL = 'https://mcard.mswipeota.com/MSwipeCreditEMIApi/api/';
  micrositeData;
  mapUrl;
  imgUrl;
  encWmc;
  decWmc;
  encWmn;
  decWmn;
  payAmount;
  aesReqEnc: string;
  paymentData;
  map: any;
  markers = [];
  paymentForm = {
    amount: '',
    mobileno: '0',
    custcode: '',
    refid: '',
    sessiontoken: '0',
    versionno: '0',
    imeino: '',
    emailid: '',
    invoice_id: '',
    MerchantTID: null,
    CustomerId: null,
    requestId: null,
    DeviceID: '',
    ClientId: null,
    AddlNote1: '1',
    AddlNote2: '2',
    AddlNote3: '3',
    AddlNote4: '4',
    AddlNote5: '5',
    AddlNote6: '6',
    AddlNote7: '7',
    AddlNote8: '8',
    AddlNote9: '9',
    AddlNote10: '10',
    invoicefile: null,
    invoicetype: null,
    LinkValidity: null,
  };
  constructor(
    private encryption: EncryptionService,
    // private mapService: MapWrapperService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer, // public videoURL?: SafeUrl
    private spinner: NgxSpinnerService
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log(params);
      if (params.wmc && params.wmn) {
        let wmc = params.wmc;
        let wmn = params.wmn;
        this.encWmc = wmc.slice(1, -2);
        this.encWmn = wmn.slice(1, -2);
        // console.log(this.encWmc);
        // console.log(this.encWmn);
  
        const wmcdata = this.encWmc;
        const wmndata = this.encWmn;
        // DES Encryption
        // const encrypted = this.encryption.encryptUsingTripleDES(data, true);
        // console.log(encrypted);
  
        // DES Decryption
        const wmcdecrypted = this.encryption.decryptUsingTripleDES(wmcdata);
        const wmndecrypted = this.encryption.decryptUsingTripleDES(wmndata);
        // console.log(wmcdecrypted);
        // console.log(wmndecrypted);
        this.decWmc = wmcdecrypted;
        this.decWmn = wmndecrypted;
  
        if (this.decWmc && this.decWmn) {
          this.getMicrositeData();
          if (params.ispw === "true") {
            this.isPreview = true;
          } else {
            this.isPreview = false;
          }
        } else {
          // console.log('Page not found');
          window.location.href = 'https://www.mswipe.com/404.html';
        }
      } else {
        // console.log('Page not found');
        window.location.href = 'https://www.mswipe.com/404.html';
      }
    });
  }

  encodeImgUrl(args) {
    return encodeURI(args);
  }

  ngOnInit(): void {}

  openImg(args) {
    this.imgUrl = args;
    this.imgModal = !this.imgModal;
  }

  openTnC() {
    this.tncModal = !this.tncModal;
  }

  mapmyindia_removeMarker() {
    var markerlength = this.markers.length;
    if (markerlength > 0) {
      for (var i = 0; i < markerlength; i++) {
        this.map.removeLayer(
          this.markers[i]
        ); /* deletion of marker object from the map */
      }
    }
    delete this.markers;
    this.markers = [];
  }

  addMarker(position, icon, title, draggable) {
    /* position must be instance of L.LatLng that replaces current WGS position of this object. Will always return current WGS position.*/
    let mk;
    if (icon == '') {
      mk = new L.Marker(position, {
        draggable: draggable,
        title: title,
      }); /*marker with a default icon and optional param draggable, title */
      // mk.bindPopup(title);
    } else {
      mk = new L.Marker(position, {
        icon: icon,
        draggable: draggable,
        title: title,
      }); /*marker with a custom icon */
      // mk.bindPopup(title);
    }
    this.map.addLayer(mk); /*add the marker to the map*/
    return mk;
  }

  getMicrositeData() {
    this.spinner.show();
    const sendObj = {
      Cust_Code: this.decWmc,
      MobileNumber: this.decWmn,
    };
    axios({
      method: 'POST',
      url: this.baseURL + 'MSwipeCreditEMI/GetPBLDetails',
      headers: {
        'content-type': 'application/json',
      },

      data: sendObj,
    }).then(
      (response) => {
        if (response) {
          this.spinner.hide();
          // console.log(response);
          this.micrositeData = response.data;
          // console.log(this.micrositeData);
          if (this.micrositeData.PBLData) {
            this.mapmyindia_removeMarker();
  
            this.map = new MapmyIndia.Map('map', {
              center: [
                this.micrositeData.PBLData.Latitude,
                this.micrositeData.PBLData.Longitude,
              ],
              zoom: 15,
              zoomControl: true,
              hybrid: true,
            });
            var postion = new L.LatLng(
              this.micrositeData.PBLData.Latitude,
              this.micrositeData.PBLData.Longitude
            ); /*WGS location object*/
            let mark = this.addMarker(
              postion,
              '',
              'Address location',
              false
            ); /*call the add marker function*/
            this.markers.push(mark);
            this.map.setView(mark.getLatLng());
          } else {
            Swal.fire({
              title: 'Error',
              text: this.micrositeData.ResponseMessage,
              icon: 'warning',
              cancelButtonText: 'Close',
            });
          }
        } else {
          Swal.fire({
            title: 'Error',
            text: 'Something went wrong!',
            icon: 'warning',
            cancelButtonText: 'Close',
          });
        }
      },
      (error) => {
        this.spinner.hide();
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong!',
          icon: 'warning',
          cancelButtonText: 'Close',
        });
      }
    );
  }

  onSubmit(f: NgForm) {
    // console.log(f.value);
    // console.log(f.valid);
    if (f.valid) {
      this.paymentForm = {
        amount: f.value.amount,
        mobileno: '0',
        custcode: this.decWmc,
        refid: this.decWmn,
        sessiontoken: '0',
        versionno: '0',
        imeino: '',
        emailid: '',
        invoice_id: '',
        MerchantTID: null,
        CustomerId: null,
        requestId: null,
        DeviceID: '',
        ClientId: null,
        AddlNote1: '1',
        AddlNote2: '2',
        AddlNote3: '3',
        AddlNote4: '4',
        AddlNote5: '5',
        AddlNote6: '6',
        AddlNote7: '7',
        AddlNote8: '8',
        AddlNote9: '9',
        AddlNote10: '10',
        invoicefile: null,
        invoicetype: null,
        LinkValidity: null,
      };

      // this.paymentForm = {
      //   amount: f.value.amount,
      //   mobileno: '0',
      //   custcode: '9400932391',
      //   refid: '9522581777',
      //   sessiontoken: '0',
      //   versionno: '0',
      //   imeino: '',
      //   emailid: '',
      //   invoice_id: '',
      //   MerchantTID: null,
      //   CustomerId: null,
      //   requestId: null,
      //   DeviceID: '',
      //   ClientId: null,
      //   AddlNote1: '1',
      //   AddlNote2: '2',
      //   AddlNote3: '3',
      //   AddlNote4: '4',
      //   AddlNote5: '5',
      //   AddlNote6: '6',
      //   AddlNote7: '7',
      //   AddlNote8: '8',
      //   AddlNote9: '9',
      //   AddlNote10: '10',
      //   invoicefile: null,
      //   invoicetype: null,
      //   LinkValidity: null,
      // };
      // console.log(this.paymentForm);
      const aesEnc = this.encryption.encryptUsingAES256(this.paymentForm);
      // console.log(aesEnc);
      this.aesReqEnc = aesEnc;
      this.getPaymentLink();
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Enter Valid Amount',
        icon: 'warning',
        cancelButtonText: 'Close',
      });
    }
  }

  getPaymentLink() {
    this.spinner.show();
    const sendObj1 =
      'V5yo+HOjfbhwklsQuv7HzqA/VyE1vfIjhxvKstCT+iTttnNldlHsG72jmsfJIe8E9W0ccGqrxxZ0Nu8Dut4FNQ5nJbkn8aTo3hGpF/tkSXdSesxaBiwoFdY+K5MJSOVqRw0A3c71CtklTyxYEPYUeE/nZvw09Hl/R/I2T/k243P4HIwMXMx//fbRppABrBzAhVCC+F7qVhSFS3REedmeXDn6faKUScMbLj3pW243eUSXIac/U5n6uU/OzBo7pIPkliK3X0K6dscltLKuH6Q7JiOl3Vl4juYL+Ck6JRIVUNInGRNLsV8WC1w9Pf6qfpbSg2lvpmh2aX8pMDwQ54yYnbq8vIAUxCPSIxY6V26QRcff0SdL477CPDP5/FTqpj04D+miaaqqQzCHun85xsxNUWKDtlzavgQJfQDcUn8JS3uAL61QqZoucg1g82CMZ6hbLzuj+Ep0VfDrspwo2HcOTtVFODympjiFA9KFAocM3BaZY3s7UhkzJ9jdJGm2TQkvYtItas5G55EyYcqL/6J5jN2hZtjHJxrhOBRuVTCNiOD1WIoj1LPBw/Lv1RzHwieekS39bBMh49DKTfGW7ZZ3aRAXv6l1sxNE59is6/7VA7s=';
    // console.log(JSON.stringify(sendObj1));
    // console.log(typeof this.aesReqEnc);
    const sendObj = this.aesReqEnc;
    // console.log(sendObj1);
    axios({
      method: 'POST',
      // url: 'https://uat.mswipetech.co.in/MPGVer1/api/MPG/wm1',
      // url: 'https://uat.mswipetech.co.in/paymentgateway/api/IPG/wm1',
      // url: 'https://pbl.mswipeota.com/MPG/api/IPG/wm1',
      // url: 'https://mswipelive.com/MPG/api/IPG/wm1',
      // url: 'https://mqtt.mswipeota.com:8081/paymentgateway/api/IPG/wm1',
      url: 'https://pbl.mswipeota.com/Microsite/api/MIPG/wm1',
      headers: {
        'content-type': 'application/json',
        // tslint:disable-next-line:max-line-length
        // 'Authorization': 'Bearer ' + this.loginDetails.data.refresh_token
      },
      data: JSON.stringify(sendObj),
    }).then(
      (response) => {
        this.spinner.hide();
        // console.log(response);
        const aesDec = this.encryption.decryptUsingAES256(response.data);
        // console.log(JSON.parse(aesDec));
        this.paymentData = JSON.parse(aesDec);
        if (this.paymentData.status === 'True') {
          window.open(this.paymentData.smslink);
        } else {
          Swal.fire({
            title: 'Error',
            text: this.paymentData.responsemessage,
            icon: 'warning',
            cancelButtonText: 'Close',
          });
        }
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong!',
          icon: 'warning',
          cancelButtonText: 'Close',
        });
      }
    );
  }
}
